export default "__VITE_ASSET__B2ZIk_6C__"